import Vue from "vue";
import Router from "vue-router";
import Auth from '@/services/AuthService';
import Redirctr from "@/utils/Redirectr";
import Store from "@/store/index";
import Document from "@/utils/Document";

import LogoutPage from "../views/LogoutPage";
import LoginPage from "../views/LoginPage.vue";
import NotFoundPage from "../views/NotFoundPage.vue";
import RedirectPage from "../views/RedirectPage.vue";
import ActivatePage from "../views/ActivatePage";
import ForgetPasswordPage from "../views/ForgetPasswordPage";
import ResetPasswordPage from "../views/ResetPasswordPage";
import ChangePasswordPage from "../views/ChangePasswordPage";

Vue.use(Router);
const mainRoute = process.env.BASE_URL;
const router = new Router({
    mode: "history",
    routes: [
        /* ========== GUEST ROUTES ========== */
        {
            path: mainRoute + "/login",
            name: "login-page",
            component: LoginPage,
            meta: { 
                requiresAuth: false,
                title: "Login | LRC - Workplace",
                metaTags: [
                    { name: "description", content: "Login to your account." },
                ]
            }
        },
        {
            path: mainRoute + "/email-validation",
            name: "activate-page",
            component: ActivatePage,
            meta: {
                requiresAuth: false,
                title: "Activate Account | LRC - Workplace",
                metaTags: [
                    { name: "description", content: "Activate your email." },
                ]
            }
        },
        {
            path: mainRoute + "/reset-password",
            name: "reset-password-page",
            component: ResetPasswordPage,
            meta: {
                requiresAuth: false,
                title: "Reset Password | LRC - Workplace",
                metaTags: [
                    { name: "description", content: "Reset your password." },
                ]
            }
        },
        {
            path: mainRoute + "/forgot-password",
            name: "forgot-password-page",
            component: ForgetPasswordPage,
            meta: {
                requiresAuth: false,
                title: "Forgot Password | LRC - Workplace",
                metaTags: [
                    { name: "description", content: "Forgot password." },
                ]
            }
        },

        /* ========== AUTH ROUTES ========== */
        {
            path: mainRoute + "/",
            name: "login-page",
            component: LoginPage,
            meta: {
                requiresAuth: false,
                title: "Login | LRC - Workplace",
                metaTags: [
                    { name: "description", content: "Login to your account." },
                ]
            }
        },
        {
            path: mainRoute + "/change-password",
            name: "change-password-page",
            component: ChangePasswordPage,
            meta: {
                requiresAuth: true,
                userPreference: true,
                title: "Change Password | LRC - Workplace"
            }
        },
        {
            path: mainRoute + "/redirect",
            name: "redirect-page",
            component: RedirectPage,
            meta: { 
                requiresAuth: true, 
                userPreference: false,
                title: "Redirecting... | LRC - Workplace"
            }
        },
        {
            path: mainRoute + "/logout",
            name: "logout-page",
            component: LogoutPage,
            meta: { 
                requiresAuth: true, 
                userPreference: false,
                title: "Logout | LRC - Workplace"
            }
        },

        /* ========== OTHER ROUTES ========== */
        // {
        //     path: "/qw-authenticator",
        //     name: "qw-authenticator",
        //     component: QWAuthenticator,
        //     meta: { userPreference: false }
        // },
        {
            path: "*",
            name: 'notfound',
            component: NotFoundPage,
            meta: { 
                userPreference: false,
                title: "Not Found | LRC - Workplace"
            }
        }
    ]
});

/* ========== AUTH GUARD ========== */
router.beforeEach((to, from, next) => {
    Document.setDocumentTitle(to);
    Document.setMetaTags(to);

    let requiresAuth = to.meta.requiresAuth;
    let redirectR = new Redirctr(to);

    if(redirectR.hasMessage)
        Store.commit("setToastMessage", redirectR.getMessageAsObject());

    if(requiresAuth === true) {
        Auth.check()
            .then(() => next())
            .catch(() => {
                let url = "/";
                if(redirectR.hasRedirect())
                    url += `?redirectTo=${redirectR.redirectTo}`;
                next(url);
            });
    } else if(requiresAuth === false) {
        Auth.check()
            .then(() => location.href = 'https://drr.solutions/lrc-crisis')
            .catch(() => next());
    } else
        next();
});


export default router;
